<template>
  <!-- 结算报表 -->
  <div class="container">
    <div class="container_form">
      <el-form
        :inline="true"
        :model="reportForm"
        style="
          padding-top: 10px;
          padding-left: 20px;
          margin-bottom: 10px;
          background-color: #fff;
          border-radius: 8px;
        "
        size="small"
        ref="reportFormRefs"
      >
        <el-form-item label="结算批次名称" prop="settlementBatchNames">
          <el-select
            multiple
            style="width: 220px"
            filterable
            v-model="reportForm.settlementBatchNames"
            placeholder="请选择结算批次名称"
          >
            <el-option
              v-for="item in settlementBatchList"
              :key="item.settlementBatchName"
              :label="item.settlementBatchName"
              :value="item.settlementBatchName"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属公司" prop="companyIds">
          <el-select
            multiple
            style="width: 200px"
            filterable
            v-model="reportForm.companyIds"
            placeholder="请选择所属公司"
          >
            <el-option
              v-for="item in companyDrownList"
              :key="item.companyId"
              :label="item.companyManager"
              :value="item.companyId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间范围" prop="dateRange">
          <el-date-picker
            v-model="reportForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            style="width: 240px"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="安装师傅" prop="installerIds">
          <el-select
            multiple
            style="width: 200px"
            filterable
            v-model="reportForm.installerIds"
            placeholder="请选择师傅名称"
          >
            <el-option
              v-for="item in allUserList"
              :key="item.id"
              :label="item.userName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="mini" @click="getReportData">查询</el-button>
          <el-button type="info" size="mini" @click="reset">重置</el-button>
          <!-- <el-button type="success" size="mini" @click="exportReport">导出</el-button> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="container_table">
      <div class="batch-statistics-button-wrapper">
        <el-button
          type="primary"
          size="small"
          class="batch-statistics-btn"
          @click="openBatchStatistics"
          v-show="authorization('/home-admin/settlementManage/report/view')"
        >批次统计</el-button>
      </div>
      <div class="statistics-cards">
        <el-row :gutter="20">
          <el-col :span="6">
            <div class="stat-card">
              <div class="stat-title">总订单数</div>
              <div class="stat-value">{{ statistics.totalOrders }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-card">
              <div class="stat-title">总安装费用</div>
              <div class="stat-value">¥{{ statistics.totalAmount }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-card">
              <div class="stat-title">已生成结算单</div>
              <div class="stat-value">{{ statistics.paidAmount }}</div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="stat-card">
              <div class="stat-title">待生成结算单</div>
              <div class="stat-value">{{ statistics.unpaidAmount }}</div>
            </div>
          </el-col>
        </el-row>
      </div>
      <el-table
        :data="tableData"
        stripe
        height="70%"
        size="small"
        :header-cell-style="{
          'background-color': '#84aace4a',
          color: '#343333',
          'text-align': 'center',
        }"
        :cell-style="{ 'text-align': 'center' }"
      >
        <el-table-column 
          prop="settlementBatchName" 
          label="结算批次名称"
          show-overflow-tooltip
          width="200">
        </el-table-column>
        <el-table-column prop="companyName" label="所属公司"></el-table-column>
        <el-table-column prop="orderCount" label="订单数量"></el-table-column>
        <el-table-column prop="totalInstallFee" label="总安装费">
          <template slot-scope="scope">
            ¥{{ scope.row.totalInstallFee }}
          </template>
        </el-table-column>
         <el-table-column prop="draftCount" label="预结算">
           <template slot-scope="scope">
             <span 
               class="status-count-link" 
               @click="jumpToStatusPage(scope.row, 'draft')"
               v-if="scope.row.draftCount > 0"
             >
               {{ scope.row.draftCount }}
             </span>
             <span v-else>{{ scope.row.draftCount }}</span>
           </template>
         </el-table-column>
         <el-table-column prop="pendingConfirmationCount" label="待师傅确认">
           <template slot-scope="scope">
             <span 
               class="status-count-link" 
               @click="jumpToStatusPage(scope.row, 'tobe-confirmed')"
               v-if="scope.row.pendingConfirmationCount > 0"
             >
               {{ scope.row.pendingConfirmationCount }}
             </span>
             <span v-else>{{ scope.row.pendingConfirmationCount }}</span>
           </template>
         </el-table-column>
         <el-table-column prop="pendingPaymentCount" label="付款中">
           <template slot-scope="scope">
             <span 
               class="status-count-link" 
               @click="jumpToStatusPage(scope.row, 'wait-payment')"
               v-if="scope.row.pendingPaymentCount > 0"
             >
               {{ scope.row.pendingPaymentCount }}
             </span>
             <span v-else>{{ scope.row.pendingPaymentCount }}</span>
           </template>
         </el-table-column>
         <el-table-column prop="paidCount" label="已结算">
           <template slot-scope="scope">
             <span 
               class="status-count-link" 
               @click="jumpToStatusPage(scope.row, 'paid')"
               v-if="scope.row.paidCount > 0"
             >
               {{ scope.row.paidCount }}
             </span>
             <span v-else>{{ scope.row.paidCount }}</span>
           </template>
         </el-table-column>
         <el-table-column prop="pendingSettlementCount"  width="95" label="待生成结算单"></el-table-column>
        <el-table-column prop="currentStatus" label="当前状态">
          <template slot-scope="scope">
            <el-tag :type="getStatusTypeByText(scope.row.currentStatus)">
              {{ scope.row.currentStatus }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="minCreateTime" label="最早创建时间" width="150">
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.minCreateTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="260">
          <template slot-scope="scope">
            <el-button
              type="info"
              size="mini"
              class="batch-statistics-btn"
              @click="viewBatchStatistics(scope.row)"
              v-show="authorization('/home-admin/settlementManage/report/view')"
            >查看批次统计</el-button>
            <el-button
              type="primary"
              size="mini"
              @click="viewSettlementBatch(scope.row)"
            >查看结算批次</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          padding-top: 10px;
          height: 40px;
          background-color: #fff;
          width: 100%;
          border-radius: 0 0 8px 8px;
          text-align: right;
        "
      >
        <el-pagination
          background
          :page-sizes="sizes"
          layout="total,sizes,prev,pager,next"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="sizeChange"
        >        </el-pagination>
      </div>
    </div>

    <!-- 批次统计弹窗 -->
    <batch-statistics-dialog
      ref="batchStatisticsDialog"
      :settlement-batch-list="settlementBatchList"
      :all-user-list="allUserList"
    ></batch-statistics-dialog>
  </div>
</template>

<script>
import { authorization } from "../../../authorization/authorization";
import BatchStatisticsDialog from "./components/BatchStatisticsDialog.vue";

export default {
  name: "SettlementReport",
  components: {
    BatchStatisticsDialog,
  },
  data() {
    return {
      reportForm: {
        settlementBatchNames: [],
        companyIds: [],
        dateRange: [],
        installerIds: [],
      },
      tableData: [],
      statistics: {
        totalOrders: 0,
        totalAmount: '0.00',
        paidAmount: '0.00',
        unpaidAmount: '0.00',
      },
      total: 0,
      sizes: [10, 15, 50, 100],
      pageSize: 10,
      pageNum: 1,
      companyDrownList: [],
      settlementBatchList: [],
      allUserList: this.$store.state.allUserList || [],
    };
  },
  created() {
    this.getCompanyDrown();
    this.getSettlementBatchList();
    this.loadAllUserList();
    // 处理从其他页面跳转过来的查询参数
    this.handleRouteQuery();
  },
  methods: {
    authorization,
    // 加载所有用户列表
    async loadAllUserList() {
      try {
        // 调用store的action来获取最新的用户列表
        await this.$store.dispatch('setAllUserList');
        // 更新本地数据
        this.allUserList = this.$store.state.allUserList;
      } catch (error) {
        console.error('加载用户列表失败:', error);
        this.$message.error('加载用户列表失败');
      }
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getReportData();
    },
    sizeChange(val) {
      this.pageSize = val;
      this.getReportData();
    },
    getReportData() {
      // 获取报表数据
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        settlementBatchNames: this.reportForm.settlementBatchNames,
        companyIds: this.reportForm.companyIds,
        startTime: this.reportForm.dateRange && this.reportForm.dateRange[0] ? this.reportForm.dateRange[0] + ' 00:00:00' : '',
        endTime: this.reportForm.dateRange && this.reportForm.dateRange[1] ? this.reportForm.dateRange[1] + ' 23:59:59' : '',
        installerIds: this.reportForm.installerIds,
      };
      
      this.axios({
        method: "post",
        url: "/settlement-report/page",
        data: params,
      }).then((res) => {
        if (res.data.code === 200) {
          this.tableData = res.data.data.list || [];
          this.total = res.data.data.total || 0;
          // 获取统计汇总信息
          this.getSummaryData();
        } else {
          this.$message.error(res.data.message || '获取报表数据失败');
          this.tableData = [];
          this.total = 0;
        }
      }).catch((err) => {
        console.error('获取报表数据失败:', err);
        this.$message.error('网络错误，请稍后重试');
        this.tableData = [];
        this.total = 0;
      });
    },
    exportReport() {
      // 导出报表
      const params = {
        settlementBatchNames: this.reportForm.settlementBatchNames,
        companyIds: this.reportForm.companyIds,
        startDate: this.reportForm.dateRange && this.reportForm.dateRange[0] ? this.reportForm.dateRange[0] : '',
        endDate: this.reportForm.dateRange && this.reportForm.dateRange[1] ? this.reportForm.dateRange[1] : '',
        installerIds: this.reportForm.installerIds,
      };
      
      this.axios({
        method: "post",
        url: "/settlement-report/export",
        data: params,
        responseType: 'blob'
      }).then((res) => {
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `结算报表_${new Date().getTime()}.xlsx`;
        link.click();
        window.URL.revokeObjectURL(url);
        this.$message.success('导出成功');
      }).catch((err) => {
        console.error('导出失败:', err);
        this.$message.error('导出功能暂未实现');
      });
    },
    reset() {
      // 手动清空查询条件
      this.reportForm.settlementBatchNames = [];
      this.reportForm.companyIds = [];
      this.reportForm.dateRange = [];
      this.reportForm.installerIds = [];
      // 重置后自动查询
      this.getReportData();
    },
    getCompanyDrown() {
      this.axios({
        method: "get",
        url: "/v1/web/company-manager/select-company-drown",
      }).then((res) => {
        this.companyDrownList = res.data.data;
      });
    },
    getSettlementBatchList() {
      // 获取结算批次列表
      this.axios({
        method: "post",
        url: "/pending-settlement-order/listSettlementName",
      }).then((res) => {
        if (res.data.code === 200) {
          this.settlementBatchList = res.data.data.map(name => ({
            settlementBatchName: name
          }));
        } else {
          this.$message.error(res.data.message || '获取结算批次列表失败');
          this.settlementBatchList = [];
        }
      }).catch((err) => {
        console.error('获取结算批次列表失败:', err);
        this.$message.error('获取结算批次列表失败，请稍后重试');
        this.settlementBatchList = [];
      });
    },
    getSummaryData() {
      // 获取统计汇总数据
      const params = {
        settlementBatchNames: this.reportForm.settlementBatchNames,
        companyIds: this.reportForm.companyIds,
        startTime: this.reportForm.dateRange && this.reportForm.dateRange[0] ? this.reportForm.dateRange[0] + ' 00:00:00' : '',
        endTime: this.reportForm.dateRange && this.reportForm.dateRange[1] ? this.reportForm.dateRange[1] + ' 23:59:59' : '',
        installerIds: this.reportForm.installerIds,
      };
      
      this.axios({
        method: "post",
        url: "/settlement-report/summary",
        data: params,
      }).then((res) => {
        if (res.data.code === 200) {
          const data = res.data.data;
          this.statistics = {
            totalOrders: data.totalOrderCount || 0,
            totalAmount: (data.totalInstallFee || 0).toFixed(2),
            paidAmount: data.createdSettlementCount || 0,
            unpaidAmount: data.pendingSettlementCount || 0,
          };
        } else {
          console.error('获取统计汇总数据失败:', res.data.message);
          // 重置统计信息
          this.resetStatistics();
        }
      }).catch((err) => {
        console.error('获取统计汇总数据失败:', err);
        // 重置统计信息
        this.resetStatistics();
      });
    },
    getStatusTypeByText(statusText) {
      const statusMap = {
        '待结算': 'warning',
        '结算中': 'primary',
        '已结算': 'success',
        '已取消': 'info'
      };
      return statusMap[statusText] || 'info';
    },
    resetStatistics() {
      // 重置统计信息为默认值
      this.statistics = {
        totalOrders: 0,
        totalAmount: '0.00',
        paidAmount: '0',
        unpaidAmount: '0',
      };
    },
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return '';
      // 格式化日期时间显示
      const date = new Date(dateTimeStr);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    viewSettlementBatch(row) {
      // 跳转到待结算订单页面，并自动查询当前结算批次
      this.$router.push({
        path: '/home-admin/settlement-model/pending-settlement',
        query: { 
          settlementBatchName: row.settlementBatchName,
          autoSearch: 'true'
        }
      });
    },
    jumpToStatusPage(row, status) {
      // 根据状态跳转到对应的结算单页面
      const routeMap = {
        'draft': '/home-admin/settlement-model/draft',
        'tobe-confirmed': '/home-admin/settlement-model/tobe-confirmed',
        'wait-payment': '/home-admin/settlement-model/wait-payment',
        'paid': '/home-admin/settlement-model/paid'
      };
      
      const targetPath = routeMap[status];
      if (targetPath) {
        this.$router.push({
          path: targetPath,
          query: { 
            settlementBatchName: row.settlementBatchName,
            autoSearch: 'true'
          }
        });
      }
    },
    handleRouteQuery() {
      // 处理从其他页面跳转过来的查询参数
      const query = this.$route.query;
      if (query.settlementBatchName && query.autoSearch === 'true') {
        // 设置结算批次名称并自动查询
        this.reportForm.settlementBatchNames = [query.settlementBatchName];
        // 等待数据加载完成后再查询
        this.$nextTick(() => {
          setTimeout(() => {
            this.getReportData();
          }, 500); // 给一点时间让下拉选项加载完成
        });
      } else {
        // 正常加载数据
        this.getReportData();
      }
    },
    openBatchStatistics() {
      // 打开批次统计弹窗
      this.$refs.batchStatisticsDialog.open();
    },
    viewBatchStatistics(row) {
      // 查看指定批次的统计
      this.$refs.batchStatisticsDialog.open([row.settlementBatchName]);
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  width: 100%;
  height:100%;
  padding: 20px;
  background-color: rgb(238, 238, 238);
  box-sizing: border-box;

  .container_form{
    ::v-deep .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item{
    margin-bottom: 10px !important;
  }
  }
}
.container_table {
  height: 100vh;
  padding: 20px 5px 0 20px;
  background-color: #fff;
  border-radius: 8px;
  padding-top: 15px;
}
.statistics-cards {
  margin-bottom: 12px;
  /* padding-inline: 20px; */
  padding-right: 15px;
}
.stat-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 20px;
  border-radius: 8px;
  text-align: center;
  padding-block: 10px;
}
.stat-title {
  font-size: 14px;
  margin-bottom: 0px;
  opacity: 0.9;
}
.stat-value {
  font-size: 24px;
  font-weight: bold;
}
 ::v-deep .el-dialog__body {
   padding-top: 0px;
 }
 .status-count-link {
   color: #409EFF;
   cursor: pointer;
 }
 .status-count-link:hover {
   text-decoration: underline;
 }
 .batch-statistics-button-wrapper {
   margin-bottom: 10px;
   text-align: left;
 }
 ::v-deep .batch-statistics-btn {
   background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
   border: none !important;
   color: white !important;
   font-weight: 500;
   box-shadow: 0 2px 8px rgba(102, 126, 234, 0.3);
   transition: all 0.3s ease;
 }
 ::v-deep .batch-statistics-btn:hover {
   background: linear-gradient(135deg, #764ba2 0%, #667eea 100%) !important;
   box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
   transform: translateY(-1px);
   color: white !important;
 }
 ::v-deep .batch-statistics-btn:active {
   transform: translateY(0);
   box-shadow: 0 2px 6px rgba(102, 126, 234, 0.3);
   color: white !important;
 }
 ::v-deep .batch-statistics-btn:focus {
   background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
   color: white !important;
 }
</style>
